import { IconType, SvgIcon } from './SvgIcon';

export const HeartIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M12.6654 9.33333C13.6587 8.36 14.6654 7.19333 14.6654 5.66667C14.6654 4.69421 14.2791 3.76158 13.5914 3.07394C12.9038 2.38631 11.9712 2 10.9987 2C9.82536 2 8.9987 2.33333 7.9987 3.33333C6.9987 2.33333 6.17203 2 4.9987 2C4.02624 2 3.09361 2.38631 2.40597 3.07394C1.71834 3.76158 1.33203 4.69421 1.33203 5.66667C1.33203 7.2 2.33203 8.36667 3.33203 9.33333L7.9987 14L12.6654 9.33333Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

HeartIcon.displayName = 'HeartIcon';
